import {Group} from "react-konva";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {mapImageTransform} from "@/dungeons/geometry/Coordinates.ts";
import DungeonGridShape from "@/dungeons/geometry/DungeonGridShape.tsx";

/** Uses the same map registration and grid shape as the dungeon editor. */
export default function DungeonGridLayer({screenScale}: {screenScale: number}) {
    const {dungeon, dungeonSettings} = useDungeon();
    if (!dungeonSettings.showGrid) return null;

    const level = dungeon.levels.find(candidate => candidate.id === dungeonSettings.levelId);
    if (!level) return null;
    const opacity = dungeonSettings.gridOpacity;
    if (!Number.isFinite(opacity) || opacity <= 0) return null;
    const transform = mapImageTransform(level.geometry);
    return <Group {...transform} listening={false}>
        <DungeonGridShape width={level.map.image.width} height={level.map.image.height}
                          registration={level.geometry.registration}
                          zoom={screenScale * transform.scaleX}
                          color="#404040" opacity={opacity}/>
    </Group>;
}
